module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-maintenance-duration/master-maintenance-duration.component.scss
// module id = ./src/app/master/master-maintenance-duration/master-maintenance-duration.component.scss
// module chunks = main